export default {
  // FAILED_CONNECTION_NOTIFICATION: '',
  // Do not localize {Retry}; it is a placeholder for "Retry". English translation should be, "Send failed. Retry."
  SEND_FAILED_KEY: `전송할 수 없습니다. {Retry}.`,
  // SLOW_CONNECTION_NOTIFICATION: '',
  Chat: '채팅',
  // 'Download file': '',
  // 'Microphone off': '',
  // 'Microphone on': '',
  'Listening…': '수신중…',
  Retry: '재전송하세요',
  Send: '전송',
  Sending: '전송중',
  // 'Speak': '',
  // 'Starting…': '',
  Tax: '세액',
  Total: '합계',
  'Type your message': '메세지를 입력하세요',
  // 'Upload file': '',
  VAT: '부가세'
  // 'X minutes ago':
};
